module.exports = __webpack_public_path__ + "static/media/galerija_2021 (30).727bf159.jpg";